module.exports = __webpack_public_path__ + "static/media/RP-76.225bb420.pdf";